import en from "./en.json";
import it from "./it.json";

export const resources = {
    en: {
        translation: en,
    },
    it: {
        translation: it,
    },
};
